export default "__VITE_ASSET__9a370a5d__"